import React from 'react';
import styles from './subscribeToPower.module.scss';

const SubscribeToPower = props => {
    return (
        <div className="row">
            <div className={`${styles.subscribeToPower}`}>
                <div className={`col-12 col-md-12`}>
                    <a>{props.powerInfo}</a>
                </div>
            </div>
        </div>

    );
};
export default SubscribeToPower;
